<div>
  <div
    class="ui vertical basic segment"
    fxLayout="row"
    appMargin
    marginT="5"
    appPadding="0"
    fxLayoutAlign="start center"
    fxLayoutGap="64px"
  >
    <div class="parent" fxLayout="column" fxLayoutGap="12px">
      <div class="row-1">
        {{ department?.toValue?.tccNumber }}
      </div>
      <div class="row-2">
        {{ department?.createdBy | createdByOrg }}
      </div>
      <div
        class="row-3"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="17px"
      >
        <div class="content" style="width: fit-content">
          <div class="top" style="white-space: nowrap">Issue Date</div>
          <div class="bottom" style="white-space: nowrap">
            {{ department?.toValue?.tccIssueDate | date: "d MMM, y h:mm a" }}
          </div>
        </div>
        <div class="content" style="width: fit-content">
          <div class="top" style="white-space: nowrap">Expiry Date</div>
          <div class="bottom" style="white-space: nowrap">
            {{ department?.toValue?.tccExpiryDate | date: "d MMM, y h:mm a" }}
          </div>
        </div>
        <div class="content" fxFlex="60px">
          <div class="top">Tax Office</div>
          <div class="bottom">
            {{ department?.toValue?.taxOfficeName }}
          </div>
        </div>
        <div class="content" fxFlex="100px">
          <div class="top">Date Created</div>
          <div class="bottom">
            {{ department?.dateCreated | date: "d MMM, y h:mm a" }}
          </div>
        </div>
        <div class="content" fxFlex="100px">
          <div class="top">Created By</div>
          <div class="bottom">
            {{ department?.createdBy | createdBy }}
          </div>
        </div>
        <div class="content" fxFlex="70px">
          <div class="top">Status</div>
          <div class="bottom">
            <div class="pills">
              <esl-pills
                [color]="getColorForLabel(department?.status)"
                [textColor]="getColorTextForLabel(department?.status)"
                label="{{ department?.status }}"
              ></esl-pills>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      fxFlex="25%"
      fxLayout="row"
      fxLayoutAlign="end center"
      class="text-right"
    >
      <button
        appMargin
        marginX="10px"
        suiPopup
        [popupInverted]="true"
        popupPlacement="bottom"
        popupText="View"
        (click)="viewHistory(department)"
        class="ui circular tiny button"
      >
        <img src="./assets/icons/eye.svg" alt="" />
      </button>
      <button
        class="ui circular tiny button"
        (click)="toggleEquipment()"
        suiPopup
        [popupInverted]="true"
        popupPlacement="bottom"
        [popupText]="collapseEquipment ? 'Expand' : 'Collapse'"
      >
        <i
          [ngClass]="
            collapseEquipment ? 'chevron down icon' : 'chevron up icon'
          "
        ></i>
      </button>
    </div>
  </div>

  <div [suiCollapse]="collapseEquipment">
    <div class="ui divider"></div>
    <div
      class="ui bottom attached segment"
      appPadding="0"
      [ngClass]="{ loading: pending }"
    >
      <app-contractor-history-company-record
        [units]="[department?.toValue]"
        *ngIf="department?.toValue"
      ></app-contractor-history-company-record>
      <div class="ui basic segment" *ngIf="!department?.toValue">
        <esl-empty
          [title]="'No items yet'"
          [description]="'Add items to see them here'"
          [moreInfo]="''"
          [hasPositiveAction]="false"
          [hasNegativeAction]="false"
          imgType="illustration"
        ></esl-empty>

        <!-- <div class="ui primary centered header">No records to display</div> -->
      </div>
    </div>
  </div>
  <div class="ui divider"></div>

  <!-- <div *ngIf="isBusinessName && department?.documents"> -->
  <div *ngIf="isBusinessName && department?.tovalue?.documents">
    <div class="ui divider"></div>
    <ng-container *ngFor="let doc of department?.tovalue?.documents">
      <div class="ui segment doc-wrap">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="8px">
            <div class="doc-heading">
              {{ doc.documentName }}
            </div>
            <div
              class="doc-author"
              fxLayout="column"
              fxLayoutAlign="center start"
              fxLayoutGap="6px"
            >
              <div class="doc-author-label">ADDED BY</div>
              <div
                class="doc-author-data"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="12px"
              >
                <div
                  class="doc-author"
                  fxLayout="row"
                  fxLayoutAlign="center baseline"
                  fxLayoutGap="3px"
                >
                  <img
                    src="../../../../../../../assets/icons/user-1.svg"
                    alt=""
                  />
                  <span>{{ doc.createdBy | createdBy }}</span>
                </div>
                <div
                  class="doc-date"
                  fxLayout="row"
                  fxLayoutAlign="center baseline"
                  fxLayoutGap="3px"
                >
                  <img
                    src="../../../../../../../assets/icons/clock.svg"
                    alt=""
                  />
                  <span>{{
                    doc.dateCreated | date: "d MMM, y h:mm a":"medium"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="end center" class="text-right">
            <button
              appMargin
              marginX="10px"
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="View"
              (click)="viewHistory(department)"
              class="ui circular tiny button"
            >
              <img src="./assets/icons/eye.svg" alt="" />
            </button>
            <!-- <button
            class="ui circular tiny button"
            (click)="toggleEquipment()"
            suiPopup
            [popupInverted]="true"
            popupPlacement="bottom"
            [popupText]="collapseEquipment ? 'Expand' : 'Collapse'"
            >
              <i
                [ngClass]="
                  collapseEquipment ? 'chevron down icon' : 'chevron up icon'
                "
              ></i>
            </button> -->
          </div>
        </div>
      </div>
    </ng-container>
    <div class="ui divider"></div>
  </div>
</div>
